// @flow
import { action } from "mobx";
import moment from "moment";

export default class Punchouts {
  constructor(store, object) {
    this.store = store;
    this.punchout = null;
    this.buyrateId = null;
    this.name = null;
    this.first = 0;
    this.owner = null;
    this.createdDate = null;
    this.createdDisplay = null;
    this.searchId = null;
    this.jobLabel = null;
    this.jobTitle = null;
    this.viewState = {
      selected: false,
      editing: false,
      expanded: false,
    };

    if (object) {
      this.punchout = object;
      this.buyrateId = object.buyrateId || null;
      this.name = object.name || null;
      this.shared = object.shared || false;
      this.first = 10;
      this.searchId = object.search.searchId;
      this.jobLabel = object.search.job.jobLabel;
      this.jobTitle = object.search.job.jobTitle;
      this.owner = {
        fullname: `${object.createdBy.firstName} ${object.createdBy.lastName}` || null,
        clientId: object.createdBy.userId || null,
        email: object.createdBy.email || null,
      };
      this.createdDate = moment(object.created);
      this.createdDisplay = `Created ${this.createdDate.format("MMMM D, YYYY")}`;
    }

    this.toggleEdit = action(this.toggleEdit.bind(this));
    this.toggleSelected = action(this.toggleSelected.bind(this));
    this.destroy = action(this.destroy.bind(this));
  }

  toggleEdit() {
    const viewState = this.store.punchoutsViewState.get(this.buyrateId);
    viewState.editing = !viewState.editing;
  }

  toggleSelected(e, ignore1 = null, ignore2 = null, setValue = null) {
    this.store.SingleSelectedPunchout(this.punchout);

    const viewState = this.store.punchoutsViewState.get(this.buyrateId);

    if (setValue !== null) {
      viewState.selected = setValue;
      return;
    } else {
      viewState.selected = !viewState.selected;

      if (!viewState.selected && this.store.allSelected) {
        this.store.allSelected = false;
      }
    }

    if (viewState.selected === false) {
      this.store.unSelectedPunchout.push(this.punchout.buyrateId.toString());
    } else {
      for (var i = 0; i < this.store.unSelectedPunchout.length; i++) {
        if (this.store.unSelectedPunchout[i] === this.buyrateId) {
          this.store.unSelectedPunchout.splice(i, 1);
        }
      }
    }

    if (!this.store.allowMultipleItemSelection) {
      // deselect all other punchout cards
      this.store.punchoutsViewState.forEach((viewState) => {
        if (this.viewState === viewState) return;

        viewState.selected = false;
      });
    }
  }

  destroy() {
    this.store.punchouts.remove(this);
  }

  toJS() {
    return {
      buyrateId: this.buyrateId,
      name: this.name,
    };
  }

  static fromJS(store, object) {
    return new Punchouts(store, object);
  }
}
